export default __webpack_public_path__ + "static/media/UG.ae71af57.svg";